
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NEW_DISH_DETAILS_CARD_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"menuDish"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"caption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cooking_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cook_until"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewMobileImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewMobileAlterImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"composition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nutrition"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carbohydrate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fat"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"protein"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"calories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"categoryId"},"name":{"kind":"Name","value":"category_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subcategory_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subcategory_name"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NEW_DISH_CATEGORY_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"menuDish"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subcategory_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subcategory_name"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":715}};
    doc.loc.source = {"body":"fragment NEW_DISH_DETAILS_CARD_FRAGMENT on menuDish {\n    title\n    caption\n    weight\n    cooking_time\n    cook_until\n    previewImage\n    previewMobileImage\n    previewMobileAlterImage\n    composition\n    nutrition {\n        carbohydrate {\n            value\n            unit\n        }\n        fat {\n            value\n            unit\n        }\n        protein {\n            value\n            unit\n        }\n        calories {\n            value\n            unit\n        }\n    }\n    categoryId: category_id\n    category_description\n    subcategory_id\n    subcategory_name\n}\n\nfragment NEW_DISH_CATEGORY_FRAGMENT on menuDish {\n    id\n    category_id\n    category_description\n    subcategory_id\n    subcategory_name\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["NEW_DISH_DETAILS_CARD_FRAGMENT"] = oneQuery(doc, "NEW_DISH_DETAILS_CARD_FRAGMENT");
        
        module.exports["NEW_DISH_CATEGORY_FRAGMENT"] = oneQuery(doc, "NEW_DISH_CATEGORY_FRAGMENT");
        
